export const menuData = [
  {title: "About", link: "/about"},
  {title: "여행", link: "/trips"},
  {title: "Careers", link: "/"},
  {title: "Contact", link: "/"},
]